module.exports = __webpack_public_path__ + "static/media/ic-social-twitter.b229c069.svg";